var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtardecer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_541",
    "data-name": "Group 541",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.211,
    height: 8.701,
    viewBox: "0 0 17.211 8.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 17.211,
    height: 8.701,
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M0,2.151V.307a.307.307,0,0,1,.615,0V2.151a.307.307,0,0,1-.615,0",
    transform: "translate(8.297)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M.154,2.17a.307.307,0,0,0,.42-.113L1.5.459A.307.307,0,0,0,.963.152L.041,1.75a.307.307,0,0,0,.112.42Z",
    transform: "translate(10.909 0.955)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M1.752.042.155.964h0A.307.307,0,1,0,.463,1.5l1.6-.922A.307.307,0,1,0,1.754.042Z",
    transform: "translate(12.82 3.54)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M.154.574l1.6.922A.307.307,0,1,0,2.059.964L.463.042A.307.307,0,1,0,.155.574Z",
    transform: "translate(2.175 3.54)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M12.587.06A3.7,3.7,0,0,1,13.214,0c1.6,0,3.028,1.576,3.941,2.9h0a.307.307,0,1,1-.506.349C15.97,2.265,14.621.615,13.214.615a3.223,3.223,0,0,0-.791.1h0c-.123.031-.242.069-.363.111l-.1.037c-.083.031-.167.064-.25.1l-.123.054q-.125.057-.251.12l-.092.046c-.105.054-.21.112-.316.171-.055.031-.111.061-.166.094l-.172.1-.193.114-.04.024-.251.151c-.265.16-.538.32-.817.477h0a5.316,5.316,0,0,0,2.082.45.307.307,0,1,1,0,.615,6.263,6.263,0,0,1-2.762-.7l0,0-.138-.07c-.019-.009-.036-.02-.055-.031-.215-.11-.425-.225-.63-.342L7.73,2.209c-.2-.117-.4-.234-.59-.35L7.1,1.837q-.246-.148-.487-.29l-.168-.1-.167-.1c-.106-.059-.211-.116-.317-.171l-.09-.045q-.127-.064-.254-.123L5.5.964c-.084-.036-.168-.07-.252-.1l-.1-.037A2.4,2.4,0,0,0,4.875.738L4.785.715h0a3.223,3.223,0,0,0-.791-.1C2.588.615,1.238,2.265.559,3.248A.307.307,0,0,1,.053,2.9C.967,1.577,2.392,0,3.994,0h0a3.7,3.7,0,0,1,.627.06l.261.034a.576.576,0,0,1,.122.03L5.227.2a.07.07,0,0,0,.019.008A6.829,6.829,0,0,1,6.3.666L6.4.72c.144.078.289.158.433.242l.086.05q.251.147.5.3l.079.047q.21.127.425.253l.167.1q.2.114.4.223L8.6,1.99q.2-.1.392-.215c.061-.034.123-.066.182-.1.207-.12.412-.242.612-.364q.255-.154.507-.3l.08-.046q.218-.126.435-.243l.1-.054a6.783,6.783,0,0,1,1.05-.454L11.985.2Z",
    transform: "translate(0 5.319)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M5.572.495A3.99,3.99,0,0,0,0,2.374a3.3,3.3,0,0,1,.561.246,3.38,3.38,0,0,1,6.156-.046,5.05,5.05,0,0,1,.593-.167A3.989,3.989,0,0,0,5.572.495",
    transform: "translate(4.957 3.388)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M.962,2.057a.307.307,0,1,0,.532-.307L.573.152A.307.307,0,0,0,.04.459Z",
    transform: "translate(4.764 0.955)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtardecer);
export default __webpack_public_path__ + "static/media/atardecer.59af0d74eaceea0d9ab8c30b0fe81f33.svg";
export { ForwardRef as ReactComponent };